import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';

//import {DataTableDirectives} from 'angular2-datatable/datatable';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    selector: 'resourceCost',
    templateUrl: './AppViews/ResourceGrade/resourceCost.html',
    //directives: [DataTableDirectives]   
})

export class ResourceCostComponent implements OnInit {

    public constants: Constants;
    public resourceCost: any[] = [];
    public grades: any[] = [];
    public currencies: any = [];
    public Search: any = "";
    public addResourceCostData: any = { addGradeId: "", addCurrency: "" };
    public editResourceCostData: any = { editGradeId: "", editCurrency: "" };
    public isAdd: boolean = true;
    public filterGradeName: any = "";
    userDetail: any;
    active = true;
    public greater = false;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    public existsGradeName: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.getResourceCost();
        this.getCurrency();
        this.getGrade();
    }

    ExportItems() {
        ExportToExcel(this.resourceCost, "ResourceCost",
            ["TeamName", "GradeName", "Costperhour", "CurrencyName", "FromDate", "ToDate"],
            ["Team", "Grade Level", "Rate", "Currency", "From Date", "To Date"]);
    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#show-cost-filter").click(function () { $(".filter-form").slideToggle() });
    }

    ngAfterViewChecked() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });
    }

    public AddResourceCostFormLoad() {
        $('#btnAddResourceCostForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public OnGreater() {
        if (this.isAdd == true) {
            var inputFromDate = moment(this.addResourceCostData.addFromDate, "DD/MM/YYYY");
            var inputToDate = moment(this.addResourceCostData.addToDate, "DD/MM/YYYY");
            if (inputFromDate > inputToDate) {
                this._sharedService.ShowMessage("warning|ToDate should be greater than fromDate");
                this.greater = true;
            }
            else {
                this.greater = false;
            }
        }
        else {
            var inputFromDate = moment(this.editResourceCostData.editFromDate, "DD/MM/YYYY");
            var inputToDate = moment(this.editResourceCostData.editToDate, "DD/MM/YYYY");
            if (inputFromDate > inputToDate) {
                this._sharedService.ShowMessage("warning|ToDate should be greater than fromDate");
                this.greater = true;
            }
            else {
                this.greater = false;
            }
        }

    }

    public getCurrency() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Currency"] }).subscribe(
            data => {
                this.currencies = data["Parameter"];
                console.log(this.currencies);

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false
            }
        );
    }
    public getGrade() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetGrade', { "ResourceGradeId": 0, "TeamId": 0 }).subscribe(
            data => {
                this.grades = data["GradeList"];
                console.log(this.grades);

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getResourceGrade() {
        this.showLoader = true;
        this._httpService.ajaxPost('ResourceGrade/GetResourceGrade', { "ResourceCostId": 0, "GradeId": 0 }).subscribe(
            data => {
                this.grades = data["ResourceGradeList"];
                console.log(this.grades);

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getResourceCost() {
        this.showLoader = true;
        this._httpService.ajaxPost('ResourceCost/GetResourceCost', { "ResourceCostId": 0, "ResourceGradeId": 0 }).subscribe(
            data => {
                this.resourceCost = data["ResourceCostList"];
                console.log(this.resourceCost);

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public clearFilter() {
        this.Search = "";
        this.filterGradeName = "";
    }

    public CancelAddResourceCost() {
        this.newForm();
        $('#addResourceCost').modal('hide');
        this.isAdd = true;
        this.existsGradeName = false;
        this.addResourceCostData = { addGradeId: "", addCurrency: "", addFromDate: "", addToDate: "", addCost: "" };
    }

    public CancelEditResourceCost() {
        this.existsGradeName = false;
        this.editResourceCostData = {};
        this.newForm();
        $('#editResourceCost').modal('hide');
        this.isAdd = true;
    }
    public AddResourceCost(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid && !this.greater) {
            this.existsGradeName = false;
            this.resourceCost.forEach(element => {
                if (element.ResourceGradeId == this.addResourceCostData.addGradeId) {
                    this.existsGradeName = true;
                }
            });
            if (!this.existsGradeName) {
                let objItem: any = {};
                objItem.ResourceCostId = 0;
                objItem.GradeId = this.addResourceCostData.addGradeId;
                objItem.Costperhour = this.addResourceCostData.addCost;
                objItem.Costperhour_Currency = this.addResourceCostData.addCurrency;
                objItem.FromDate = this.addResourceCostData.addFromDate;
                objItem.ToDate = this.addResourceCostData.addToDate;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.UpdatedBy = this.userDetail.SiteUserId;
                this.addEditResourceCost(objItem);
                $('#addResourceCost').modal('hide');
                this.addResourceCostData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
        else {
            if (this.greater) {
                this._sharedService.ShowMessage("warning|ToDate should be greater than fromDate");
            }
        }
    }

    public EditResourceCost(item: any) {
        $('#btnEditResourceCostForm').trigger('click');
        this.isAdd = false;
        this.EditResourceCostChange(item.ResourceGradeId);
    }

    public EditResourceCostChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.resourceCost.filter((resourceCost) => resourceCost.ResourceGradeId == itemId)[0]));
        this.editResourceCostData.editResourceCostId = objItem.ResourceCost_Id;
        this.editResourceCostData.editGradeId = objItem.ResourceGradeId;
        this.editResourceCostData.editGradeName = objItem.GradeName;
        this.editResourceCostData.editCost = objItem.Costperhour;
        this.editResourceCostData.editCurrency = objItem.CurrencyValue;
        this.editResourceCostData.editFromDate = objItem.FromDate;
        this.editResourceCostData.editToDate = objItem.ToDate;
    }

    public UpdateResourceCost(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid && !this.greater) {
            this.existsGradeName = false;
            this.resourceCost.forEach(element => {
                if (element.ResourceCost_Id != this.editResourceCostData.editResourceCostId && element.ResourceGradeId == this.editResourceCostData.editGradeId) {
                    this.existsGradeName = true;
                }
                else {
                    console.log("else");
                }
            });

            if (!this.existsGradeName) {
                let objItem: any = {};
                objItem.ResourceCost_Id = this.editResourceCostData.editResourceCostId;
                objItem.GradeId = this.editResourceCostData.editGradeId;
                objItem.Costperhour = this.editResourceCostData.editCost;
                objItem.Costperhour_Currency = this.editResourceCostData.editCurrency;
                objItem.FromDate = this.editResourceCostData.editFromDate;
                objItem.ToDate = this.editResourceCostData.editToDate;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.UpdatedBy = this.userDetail.SiteUserId;
                this.addEditResourceCost(objItem);
                $('#editResourceCost').modal('hide');
                this.editResourceCostData = { editGradeId: "", editCurrency: "" };
                this.newForm();
                this.isAdd = true;
            }
        }
        else {
            if (this.greater) {
                this._sharedService.ShowMessage("warning|ToDate should be greater than fromDate");
            }
        }
    }

    addEditResourceCost(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('ResourceCost/AddUpdateResourceCost', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getResourceCost();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/ResourceGrade/ResourceCost.component.ts
 **/